

import Typography from "app/shared/Typography";
import { useNavigate } from "react-router-dom";
import { colorPicker } from "app/utils/color.helper";
import { Button } from "antd";

export default function PortalDown() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "20px",
          maxWidth: "600px",
        }}
      >
        <div
          style={{
            fontSize: 72,
            marginBottom: 24,
            color: colorPicker("error.500") || "#ff4d4f",
          }}
        >
          ⚠️
        </div>
        <Typography
          style={{
            color: colorPicker("neutral.900"),
            marginBottom: 16,
          }}
          variant="h4"
        >
          Portal is Down
        </Typography>
        <Typography
          variant="body1"
          style={{
            color: colorPicker("neutral.700"),
            marginBottom: 32,
            maxWidth: "500px",
          }}
        >
          We're sorry, but the portal is currently unavailable for your email
          domain. Please contact your administrator for assistance.
        </Typography>
        {/* <Button
          type="primary"
          size="large"
          onClick={() => navigate("/auth/signin")}
        >
          Back to Sign In
        </Button> */}
      </div>
    </div>
  );
}